import {Component, Input, OnChanges, SecurityContext, SimpleChanges} from '@angular/core';

import {marked} from 'marked';

// @ts-ignore
import customHeadingId from 'marked-custom-heading-id';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

marked.use(customHeadingId());

@Component({
    selector: 'app-markdown',
    templateUrl: './markdown.component.html',
    styleUrls: ['./markdown.component.scss'],
    standalone: true
})
export class MarkdownComponent implements OnChanges {

  @Input()
  markup?: string ;

  @Input()
  trustHtml: boolean = false;

  html?: SafeHtml ;

  constructor(
    private _sanitizer:DomSanitizer
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (!this.markup) {
      return;
    }

    let parsed : string | null = marked.parse(this.markup) ;
    if (!this.trustHtml) {
      parsed = this._sanitizer.sanitize(SecurityContext.HTML, parsed)
    }
    if (parsed) {
      this.html = this._sanitizer.bypassSecurityTrustHtml(parsed);
    }
  }



}
